import type { IconId } from '#/components/ui/icons';
import { SectionHeader } from '#/components/ui/SectionHeader';
import { SimpleCard } from '#/components/ui/SimpleCard';
import type { CategoryToolCard } from '#/content/category';

interface ToolsResourcesSectionProps {
  cards: CategoryToolCard[];
  /** GTM `data-track` id forwarded onto each card's anchor (link variant). */
  cardTrack?: string;
  /** GTM `data-track-context` forwarded onto each card's anchor (link variant). */
  cardTrackContext?: string;
}

/** Drupal `icon_name` values we render; anything else falls back below. */
const TOOL_ICON_IDS = new Set<IconId>([
  'newspaper',
  'chart',
  'folder',
  'search',
  'download',
]);

function resolveToolIcon(name: string | null): IconId {
  return name && TOOL_ICON_IDS.has(name as IconId)
    ? (name as IconId)
    : 'newspaper';
}

export function ToolsResourcesSection({
  cards,
  cardTrack,
  cardTrackContext,
}: ToolsResourcesSectionProps) {
  return (
    <section
      id="tools-resources"
      className="flow flow-inner-20 scroll-mt-(--scroll-offset)"
    >
      <SectionHeader title="Tools & Resources" />

      <div className="grid gap-20 lg:grid-cols-3">
        {cards.map((card) => (
          <SimpleCard
            key={card.id}
            title={card.title}
            href={card.href ?? undefined}
            icon={resolveToolIcon(card.icon)}
            content={card.body}
            target="_blank"
            rel="noopener noreferrer"
            dataTrack={cardTrack}
            dataTrackLabel={cardTrack ? card.title : undefined}
            dataTrackContext={cardTrackContext}
          />
        ))}
      </div>
    </section>
  );
}
